<template>
    <div class="card card-box " style="border-radius : 0%; min-height: 650px;">
      <div class="card-body">
        <b-form>
          <div class="row">
            <div class="col-md-12 mt-2">
              <h4 class="__blue" style="font-weight: 700">
                Fasilitas
              </h4>
            </div>
            <div
              class="col-md-3 mt-3"
              v-for="(initial, index) in dataFasilitas"
              :key="index"
            >
              <b-form-checkbox
                v-model="dataFasilitas[index].checked"
                :value="1"
                unchecked-value="0"
                @click.native.prevent="!hasFeatures('klinik')"
                @input="onChange($event, index)"
              >
                {{ initial.nama }}
              </b-form-checkbox>
            </div>
  
            <br />
            <br />
            <div class="col-md-12 mt-3 mb-2">
              <hr />
              <br />
              <h4 class="__blue mt-1" style="font-weight: 700">
                Jadwal Dokter
              </h4>
            </div>
            <div class="col-md-12 mt-3" v-if="dataJadwal.length != 0" id="scheduleTable">
                <b-table striped hover :items="dataJadwal" :fields="fields">
                  <template #cell(nama_poliklinik)="data">
                      <div class="border-right pl-3" v-if="data.item.nama_poliklinik.length > 10" v-tooltip="{
                        content: data.item.nama_poliklinik,
                        classes: 'schedule-tooltip',
                        trigger: 'hover',
                      }">
                        {{ data.item.nama_poliklinik.slice(0, 10) + (data.item.nama_poliklinik.length > 10 ? '...' : '')  }}
                      </div>
                      <div class="border-right pl-3" v-else>
                        {{ data.item.nama_poliklinik.slice(0, 10) + (data.item.nama_poliklinik.length > 10 ? '...' : '')  }}
                      </div>
                  </template>
                  <template #cell(dokter)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index">
                      <div v-if="item.dokter_name.length > 10" v-tooltip="{
                        content: item.dokter_name,
                        classes: 'schedule-tooltip',
                        trigger: 'hover',
                      }" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                        {{ item.dokter_name.slice(0, 10) + (item.dokter_name.length > 10 ? '...' : '')  }}
                      </div>  
                      <div v-else :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                        {{ item.dokter_name.slice(0, 10) + (item.dokter_name.length > 10 ? '...' : '')  }}
                      </div>  
                    </div>
                  </template>
                  <template #cell(senin)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                      {{ item.days[0].time || '-' }}
                    </div>
                  </template>
                  <template #cell(selasa)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                      {{ item.days[1].time || '-' }}
                    </div>
                  </template>
                  <template #cell(rabu)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                      {{ item.days[2].time || '-' }}
                    </div>
                  </template>
                  <template #cell(kamis)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                      {{ item.days[3].time || '-'}}
                    </div>
                  </template>
                  <template #cell(jumat)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                      {{ item.days[4].time || '-' }}
                    </div>
                  </template>
                  <template #cell(sabtu)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`"> 
                      {{ item.days[5].time || '-'}}
                    </div>
                  </template>
                  <template #cell(minggu)="data">
                    <div v-for="(item, index) in data.item.jadwal" :key="index" :class="index == (data.item.jadwal.length - 1) ?  `pt-2 pb-2 pl-2` : `border-bottom pt-2 pb-2 pl-2`">
                      {{ item.days[6].time || '-'}}
                    </div>
                  </template>
                </b-table>
            </div>
            <div class="col-md-12" v-else>
              <label for="">-</label>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </template>
  
  <script>
  
  import { mapGetters } from "vuex";
  import { EventBus } from "../../../event-bus";
  
  export default {
    components: {},
    data() {
      return {
        status: false,
        dataCheckBox: [],
        initial: 0,
        dataJadwal: [],
        dataFasilitas: [],
        photo: null,
  
        fields: [
          {
            key: 'nama_poliklinik',
            label: 'Poli',
            // thStyle: { width: "130px" },
          },
          {
            key: 'dokter',
            label: 'Nama Dokter',
            // thStyle: { width: "150px" },
          },
          {
            key: 'senin',
            label: 'Senin'
          },
          {
            key: 'selasa',
            label: 'Selasa'
          },
          {
            key: 'rabu',
            label: 'Rabu'
          },
          {
            key: 'kamis',
            label: 'Kamis'
          },
          {
            key: 'jumat',
            label: 'Jumat'
          },
          {
            key: 'sabtu',
            label: 'Sabtu'
          },
          {
            key: 'minggu',
            label: 'Minggu'
          },
        ]
      };
    },
    computed: {
      ...mapGetters(["getKlinikId", "getRolesName"])
    },
    mounted() {
      window.scrollTo({
        top: 95,
        behavior: "smooth"
      });
  
      this.getDataJadwal();
      this.getDataFasilitas();

      
    },
    methods: {
      async onChange(data, index) {
        if(!this.hasFeatures('klinik')) {
          this.dataFasilitas[index].checked = 0
          return false;
        }

        try {
          const res = await this.$axios.post(`klinik/fasilitas`, {
            klinik_id: this.getKlinikId,
            fasilitas_id: index + 1,
            checked: data
          });
        } catch (error) {}
      },
      hasFeatures(value) {
        const features = {
          klinik: ["pic_cabang", "pic_pusat"],
          dokter: ["dokter_klinik"]
        };
        const isOwner = features[value].filter(feature => {
          return this.getRolesName.includes(feature);
        });
        return isOwner.length > 0 ? true : false;
      },
      async getDataJadwal() {
        try {  
          const res = await this.$axios.get(
            `poliklinik/jadwal?klinik_id=${this.getKlinikId}`
          );
  
          const { data } = res.data;
          this.dataJadwal = res.data.data
          EventBus.$emit('count-schedule', (this.dataJadwal.length));
          window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
          // console.log(error)
        }
      },
      async getDataFasilitas() {
        try {
          const res = await this.$axios.get(
            `klinik/fasilitas?klinik_id=${this.getKlinikId}`
          );
          this.dataFasilitas = res.data.data;
          this.dataCheckBox = this.dataFasilitas;
        } catch (error) {}
      }
    }
  };
  </script>
  
  <style>
  
  #scheduleTable .table td {
    width: 80px;
    padding-left: 0;
    padding-right: 0;
  }
  
  /* #scheduleTable .table td div {
    padding-left: 5px;
    padding-right: 5px;
  } */
  
  #scheduleTable .table td:nth-child(1), #scheduleTable .table th:nth-child(1) {
    border-right: 1px solid #cdcdcd;
  }
  
  #scheduleTable .table tr:last-child {
    border-bottom: 1px solid #cdcdcd;
  }
  
  
  .schedule-tooltip .tooltip-inner {
    background: #ffffff !important;
    color: #858585 !important;
  }
  
  .schedule-tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #ffffff;
    z-index: 1;
  }
  
  @media only screen and (max-width: 1400px) {
    #scheduleTable {
      overflow-x: scroll;
    }
  
    #scheduleTable .table {
      width: 120%;
    }
  }
  
  </style>
  <style scoped>
  .__blue {
    color: #4b80b6;
  }
  
  ._outer_klinik_profile {
    /* outline-style: auto; */
    cursor: pointer;
  }
  
  .__outer_line_profile {
    border-right: rgb(121, 121, 121);
    border-left: none;
    border-top: none;
    border-bottom: none;
    /* position: absolute; */
    border-right-style: solid;
  }
  
  .__icon_add_photo {
    position: absolute;
    top: 12px;
    left: 14px;
  }
  .__btn_add_photo {
    position: absolute;
    top: 85px;
    right: 15px;
    z-index: 10;
    border-radius: 50%;
    height: 44px !important;
    background-color: rgb(121, 121, 121);
  }
  .badge-alert {
    background-color: #ffffff;
    border: solid 1px rgba(7, 9, 25, 0.5) !important;
    border-radius: 50%;
    cursor: pointer;
  }
  
  .border-bottom {
    border-color: #cdcdcd !important;
  }
  </style>
  